// app/translate/translate.service.ts
import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable, Inject } from '@angular/core';
import { TRANSLATIONS } from './translations';
import { Subject } from 'rxjs/Subject';
import { Subscriber } from 'rxjs/Subscriber';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { catchError } from 'rxjs/operators';
@Injectable()
export class TranslateService {
    private _currentLang: string = "english";
    private _requested: boolean = false;
    private _arrived: boolean = false;
    private langCallbackSubject = new Subject<string>();

    private _language: BehaviorSubject<string> = new BehaviorSubject('english');
    public readonly language$: Observable<string> = this._language.asObservable();

    // inject our translations
    constructor( @Inject(TRANSLATIONS) private _translations: any, private _http: HttpClient) {
        this.init();
    }

    private init(): void {
        this._requested = true;
        this.getUserLanguage().subscribe(result => {
          this._language.next(result);
            this._currentLang = result;
            this._arrived = true;
            this._requested = false;
            this._sendPrefLang(result);
        });
    }

    public changeLanguage(language: string) {
      this._language.next(language);
    }

    public getUserLanguage(): Observable<string> {
      return this._http.get<string>("Api/User/GetUserLanguage").pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    _sendPrefLang(lang: string) {
      this._language.next(lang);
        this.langCallbackSubject.next(lang);
    }

    _getPrefLang(): Observable<string> {
      return this.language$;
    }

    public translateToLang(key: string, lang: string): any {
        if (this._translations[lang] && this._translations[lang][key])
          return this._translations[lang][key];
        // console.log('TRANSLATION REQUIRED: \'' + key + '\'');
        return key;
    }
}
